module.exports = __webpack_public_path__ + "static/media/audio-preview.6badac92.png";